import React, { useState, useEffect } from "react";
import { Stack } from "@mui/material";
import FilterContainer from "../FilterContainer";
import { IFilterProps } from "../../../../types/filter.type";
import FilterText from "../FilterText";
import FilterSelectApi from "../FilterSelectApi";
import FilterTimeFromTo from "../FilterTimeFromTo";
import moment from "moment";

function FilterFeedComment({ setCondition }: IFilterProps) {
  const originFilter: { [key: string]: any } = {
    content: "",
    user: null,
    parent: null,
    dangTu: null,
    dangDen: null,
  };
  const [filter, setFilter] = useState(originFilter);

  const handleRefreshFilter = () => {
    setFilter(originFilter);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.content) {
      condition.content = {
        $regex: filter.content?.split(" ")?.join(".*"),
        $options: "i",
      };
    }
    if (filter.user) {
      condition.user_created = filter.user.email;
    }
     if (filter.dangTu || filter.dangDen) {
       const startDate = moment(filter.dangTu).startOf('days');
       const endDate = moment(filter.dangDen).endOf('days');
          if (filter.dangTu && filter.dangDen) {
            condition.date_created = { $gte: startDate, $lte: endDate };
          } else if (filter.dangTu) {
            condition.date_created = { $gte: startDate };
          } else if (filter.dangDen) {
            condition.date_created = { $lte: endDate };
          }
        }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <FilterContainer handleRefreshFilter={handleRefreshFilter}>
      <Stack sx={{ width: "100%" }} spacing="10px">
        <FilterText
          title="Nội dung"
          placeholder="Tìm theo nội dung"
          value={filter.content}
          onSearch={(value) => setFilter({ ...filter, content: value })}
        />
        <FilterSelectApi
          direction="column"
          title="Người đăng"
          apiCode="participant"
          placeholder="Chọn người đăng"
          value={filter.user}
          searchFields={["name", "email"]}
          getOptionLabel={(option) => `${option.email} (${option.name})`}
          checkEqual={(value, option) => value?.email === option?.email}
          onChange={(value) => setFilter({ ...filter, user: value })}
        />
        <FilterTimeFromTo
          title="Ngày đăng"
          defaultTimeFrom={filter.dangTu}
          defaultTimeTo={filter.dangDen}
          onSearch={(time) =>
            setFilter({
              ...filter,
              dangTu: time.timeFrom,
              dangDen: time.timeTo,
            })
          }
        />
      </Stack>
    </FilterContainer>
  );
}

export default FilterFeedComment;
